interface RatingFilterProps {
  value: number;
  onChange: (value: number) => void;
}

const options: { value: number; label: string }[] = [
  { value: 0, label: "All ratings" },
  { value: 4.5, label: "4.5 & above" },
  { value: 4, label: "4.0 & above" },
  { value: 3.5, label: "3.5 & above" },
  { value: 3, label: "3.0 & above" },
];

function MiniStars({ value }: { value: number }) {
  return (
    <span className="flex items-center gap-0.5 text-accent-500">
      {[1, 2, 3, 4, 5].map((star) => {
        const icon =
          value >= star ? "ri-star-fill" : value >= star - 0.5 ? "ri-star-half-fill" : "ri-star-line";
        return (
          <span key={star} className="flex h-3.5 w-3.5 items-center justify-center">
            <i className={`${icon} text-[13px]`} />
          </span>
        );
      })}
    </span>
  );
}

export default function RatingFilter({ value, onChange }: RatingFilterProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <h3 className="flex items-center gap-2 font-heading text-xs font-bold uppercase tracking-wider text-foreground-900">
        <span className="flex h-4 w-4 items-center justify-center text-accent-500">
          <i className="ri-star-smile-line text-base" />
        </span>
        Filter by rating
      </h3>

      <ul className="mt-4 space-y-1">
        {options.map((option) => {
          const isActive = value === option.value;
          return (
            <li key={option.value}>
              <button
                type="button"
                onClick={() => onChange(option.value)}
                aria-pressed={isActive}
                className={`flex w-full cursor-pointer items-center justify-between gap-3 rounded-md px-3 py-2.5 text-left text-sm font-medium transition-colors duration-200 ${
                  isActive
                    ? "bg-secondary-500 text-background-50"
                    : "text-foreground-700 hover:bg-background-100 hover:text-secondary-900"
                }`}
              >
                <span>{option.label}</span>
                {option.value > 0 ? (
                  isActive ? (
                    <span className="flex items-center gap-0.5 text-background-50">
                      <span className="flex h-3.5 w-3.5 items-center justify-center">
                        <i className="ri-star-fill text-[13px]" />
                      </span>
                      <span className="text-xs font-bold">{option.value.toFixed(1)}</span>
                    </span>
                  ) : (
                    <MiniStars value={option.value} />
                  )
                ) : null}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}